"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcHeader = class UcHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    modal;
    onModal(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("modal");
    }
    card;
    onCard(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("card");
    }
    dialogName;
    onDialog_name(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("dialogName");
    }
    title;
    onTitle(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("title");
    }
    color;
    onColor(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("color");
    }
    resourceTitle;
    onResource_title(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("resourceTitle");
    }
    resourceKey;
    onResource_key(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("resourceKey");
    }
    ux;
    b_2248226175642056_class;
    dataMembers = ['ux', 'b_2248226175642056_class'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
                b_2248226175642056_class: {
                    "items-spacing": true,
                    "w-100": true,
                    "mr-3": true,
                },
            },
        };
    }
    get borderClass() {
        if (this.loaded) {
            return this.color ? 'uc-border border-top-' + this.color : '';
        }
        return null;
    }
    async act_5962862420439144_emit_2558_getActionArgs($event) {
        return {
            event: "close",
        };
    }
    async evh_5962862420439144_click(event, scope) {
        return await this.actions.evh_5962862420439144_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5962862420439144_emit_2558 = new core_1.actions.EmitAction({
            actionArgs: this.act_5962862420439144_emit_2558_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_click_2557 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_emit_2558,
            event: "click",
            displayName: "emit",
        });
        const evh_5962862420439144_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_click_2557],
        });
        return {
            act_5962862420439144_emit_2558,
            evh_5962862420439144_click_2557,
            evh_5962862420439144_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcHeader.prototype, "modal", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('modal'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcHeader.prototype, "onModal", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcHeader.prototype, "card", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('card'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcHeader.prototype, "onCard", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcHeader.prototype, "dialogName", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('dialogName'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcHeader.prototype, "onDialog_name", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcHeader.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('title'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcHeader.prototype, "onTitle", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcHeader.prototype, "color", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('color'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcHeader.prototype, "onColor", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcHeader.prototype, "resourceTitle", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('resourceTitle'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcHeader.prototype, "onResource_title", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcHeader.prototype, "resourceKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('resourceKey'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcHeader.prototype, "onResource_key", null);
UcHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcHeader);
exports.default = UcHeader;
vue_property_decorator_1.Vue.component("UcHeader", UcHeader);
